module.exports = __webpack_public_path__ + "static/media/pic3.d5f1b9fc.jpg";